'use client'
import { useState } from 'react'
import { useSearchParams } from 'next/navigation'
import { Suspense } from 'react'

const League = () => {
  const [iframeId, setIframeId] = useState('')
  const Iframe = () => {
    const searchParams = useSearchParams()
    setIframeId(searchParams.get('id'))
    return (
      <iframe
        src={`https://${
          process.env.NEXT_PUBLIC_STAGE !== 'pro'
            ? 'fcpadel.iberowan.com'
            : 'gestio.fcpadel.cat'
        }/ligas_calendario.aspx?idCategoria=${iframeId}`}
        className="absolute top-0 bottom-0 left-0 w-full h-full"
      ></iframe>
    )
  }

  return (
    <div className="bg-[#f2f3f3] pt-20">
      <div className="relative block h-[2000px] lg:h-[1500px] overflow-hidden">
        <Suspense>
          <Iframe />
        </Suspense>
      </div>
    </div>
  )
}

export default League
